import { render } from "./custom-field-edit.vue?vue&type=template&id=e5f99e3c"
import script from "./custom-field-edit.vue?vue&type=script&lang=js"
export * from "./custom-field-edit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\BijouCRM\\src\\ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__